/**
 * BaB footer "X items" selection popup
 * Underlines the items count in the Awtomic footer and opens a popup
 * listing currently selected products (qty > 0).
 */
(function () {
  var FOOTER_SELECTOR = '.bundle-container footer';
  var CARD_SELECTOR = '.bundle-product-card';
  var ITEMS_ATTR = 'data-custom-bab-items-trigger';
  var POPUP_ATTR = 'data-custom-bab-selection-popup';
  var OPEN_CLASS = 'is-open';
  var ACTIVE_CLASS = 'custom-bab-items-trigger--active';
  var ITEMS_RE = /^\s*\d+\s+items?\s*$/i;

  var updating = false;
  var scheduled = false;
  var lastFocus = null;

  function getCardQuantity(card) {
    var q = card.getAttribute('data-quantity');
    if (q !== null && q !== undefined && q !== '') {
      return parseInt(q, 10) || 0;
    }

    var qClass = Array.prototype.find.call(card.classList, function (name) {
      return /^q_\d+$/.test(name);
    });
    if (qClass) {
      return parseInt(qClass.slice(2), 10) || 0;
    }

    var span = card.querySelector('.bundle-product-card__quantity-button-container span');
    if (span) {
      return parseInt(span.textContent, 10) || 0;
    }

    return 0;
  }

  function getSelectedItems() {
    var items = [];
    document.querySelectorAll(CARD_SELECTOR).forEach(function (card) {
      var qty = getCardQuantity(card);
      if (qty <= 0) return;

      var titleEl =
        card.querySelector('.awt-product-title') ||
        card.querySelector('.bundle-product-card__title');
      var priceEl = card.querySelector('.bundle-product-card__price');
      var imgEl =
        card.querySelector('img[data-testid="lazy-image"]') ||
        card.querySelector('.bundle-lazy-image-container img:not([aria-hidden="true"])') ||
        card.querySelector('.bundle-lazy-image-container img');

      items.push({
        title: titleEl ? titleEl.textContent.trim() : 'Item',
        quantity: qty,
        price: priceEl ? priceEl.textContent.trim() : '',
        image: imgEl ? imgEl.getAttribute('src') || '' : '',
        alt: imgEl ? imgEl.getAttribute('alt') || '' : '',
      });
    });
    return items;
  }

  function findItemsSpan(footer) {
    var spans = footer.querySelectorAll('span');
    for (var i = 0; i < spans.length; i++) {
      var span = spans[i];
      if (span.closest('[' + POPUP_ATTR + ']')) continue;
      if (span.closest('.custom-bab-spend-bar')) continue;
      if (ITEMS_RE.test(span.textContent || '')) return span;
    }
    return null;
  }

  function enhanceItemsTrigger(footer) {
    var span = findItemsSpan(footer);
    if (!span) return null;

    if (!span.hasAttribute(ITEMS_ATTR)) {
      span.setAttribute(ITEMS_ATTR, '');
      span.setAttribute('role', 'button');
      span.setAttribute('tabindex', '0');
      span.setAttribute('aria-haspopup', 'dialog');
      span.setAttribute('aria-expanded', 'false');
    }

    var hasItems = getSelectedItems().length > 0;
    span.classList.toggle(ACTIVE_CLASS, hasItems);
    span.setAttribute('aria-disabled', hasItems ? 'false' : 'true');
    span.setAttribute('tabindex', hasItems ? '0' : '-1');

    var label = (span.textContent || '').trim() || 'items';
    span.setAttribute(
      'aria-label',
      hasItems ? 'View current selection: ' + label : label
    );

    return span;
  }

  function escapeHtml(text) {
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function ensurePopup() {
    var existing = document.querySelector('[' + POPUP_ATTR + ']');
    if (existing) return existing;

    var root = document.createElement('div');
    root.setAttribute(POPUP_ATTR, '');
    root.className = 'custom-bab-selection-popup';
    root.setAttribute('aria-hidden', 'true');
    root.innerHTML =
      '<div class="custom-bab-selection-popup__backdrop" data-custom-bab-selection-close></div>' +
      '<div class="custom-bab-selection-popup__dialog" role="dialog" aria-modal="true" aria-labelledby="custom-bab-selection-title" tabindex="-1">' +
      '<div class="custom-bab-selection-popup__header">' +
      '<h2 id="custom-bab-selection-title" class="custom-bab-selection-popup__title">Your selection</h2>' +
      '<button type="button" class="custom-bab-selection-popup__close" data-custom-bab-selection-close aria-label="Close selection">' +
      '<span aria-hidden="true">&times;</span>' +
      '</button>' +
      '</div>' +
      '<div class="custom-bab-selection-popup__body" data-custom-bab-selection-list></div>' +
      '</div>';

    document.body.appendChild(root);
    return root;
  }

  function renderList(popup) {
    var list = popup.querySelector('[data-custom-bab-selection-list]');
    if (!list) return;

    var items = getSelectedItems();
    if (!items.length) {
      list.innerHTML =
        '<p class="custom-bab-selection-popup__empty">No items selected yet. Add products to your box to see them here.</p>';
      return;
    }

    var html = '<ul class="custom-bab-selection-popup__list">';
    items.forEach(function (item) {
      var img = item.image
        ? '<img class="custom-bab-selection-popup__thumb" src="' +
          escapeHtml(item.image) +
          '" alt="' +
          escapeHtml(item.alt || item.title) +
          '" loading="lazy" width="56" height="56">'
        : '<div class="custom-bab-selection-popup__thumb custom-bab-selection-popup__thumb--placeholder" aria-hidden="true"></div>';

      html +=
        '<li class="custom-bab-selection-popup__item">' +
        img +
        '<div class="custom-bab-selection-popup__meta">' +
        '<p class="custom-bab-selection-popup__name">' +
        escapeHtml(item.title) +
        '</p>' +
        '<p class="custom-bab-selection-popup__details">' +
        'Qty ' +
        escapeHtml(String(item.quantity)) +
        (item.price ? ' · ' + escapeHtml(item.price) : '') +
        '</p>' +
        '</div>' +
        '</li>';
    });
    html += '</ul>';
    list.innerHTML = html;
  }

  function setTriggersExpanded(expanded) {
    document.querySelectorAll('[' + ITEMS_ATTR + ']').forEach(function (el) {
      el.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  function openPopup() {
    var popup = ensurePopup();
    renderList(popup);
    lastFocus = document.activeElement;
    popup.classList.add(OPEN_CLASS);
    popup.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('custom-bab-selection-popup-open');
    setTriggersExpanded(true);

    var dialog = popup.querySelector('.custom-bab-selection-popup__dialog');
    if (dialog) dialog.focus();
  }

  function closePopup() {
    var popup = document.querySelector('[' + POPUP_ATTR + ']');
    if (!popup || !popup.classList.contains(OPEN_CLASS)) return;

    popup.classList.remove(OPEN_CLASS);
    popup.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('custom-bab-selection-popup-open');
    setTriggersExpanded(false);

    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus();
    }
    lastFocus = null;
  }

  function isOpen() {
    var popup = document.querySelector('[' + POPUP_ATTR + ']');
    return !!(popup && popup.classList.contains(OPEN_CLASS));
  }

  function syncAll() {
    if (updating) return;
    updating = true;
    try {
      document.querySelectorAll(FOOTER_SELECTOR).forEach(enhanceItemsTrigger);
      if (isOpen()) {
        if (getSelectedItems().length === 0) {
          closePopup();
        } else {
          var popup = ensurePopup();
          renderList(popup);
        }
      }
    } finally {
      updating = false;
    }
  }

  function scheduleSync() {
    if (scheduled || updating) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      syncAll();
    });
  }

  function observe() {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var target = mutations[i].target;
        if (!target) continue;
        if (
          (target.nodeType === 1 && target.closest && target.closest('[' + POPUP_ATTR + ']')) ||
          (target.parentElement && target.parentElement.closest('[' + POPUP_ATTR + ']'))
        ) {
          continue;
        }
        scheduleSync();
        return;
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['data-quantity', 'class'],
    });
  }

  function bindEvents() {
    document.addEventListener('click', function (e) {
      var trigger = e.target && e.target.closest && e.target.closest('[' + ITEMS_ATTR + ']');
      if (trigger) {
        if (!trigger.classList.contains(ACTIVE_CLASS)) return;
        e.preventDefault();
        e.stopPropagation();
        if (isOpen()) closePopup();
        else openPopup();
        return;
      }

      var closer =
        e.target && e.target.closest && e.target.closest('[data-custom-bab-selection-close]');
      if (closer) {
        e.preventDefault();
        closePopup();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) {
        e.preventDefault();
        closePopup();
        return;
      }

      var trigger = e.target && e.target.closest && e.target.closest('[' + ITEMS_ATTR + ']');
      if (
        trigger &&
        trigger.classList.contains(ACTIVE_CLASS) &&
        (e.key === 'Enter' || e.key === ' ')
      ) {
        e.preventDefault();
        if (isOpen()) closePopup();
        else openPopup();
      }
    });
  }

  function init() {
    ensurePopup();
    syncAll();
    observe();
    bindEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
